import { INSTATUS_SUMMARY_URL } from "@/configs/instatus";

import type { InstatusResponse } from "@/api/resources/instatus/types";

export const getInstatusStatus = async (): Promise<InstatusResponse | null> => {
  try {
    const response = await fetch(INSTATUS_SUMMARY_URL);
    if (!response.ok) {
      throw new Error(`Failed to fetch instatus status: ${response.status}`);
    }

    const json = await response.json();
    return json as InstatusResponse;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // ! don't throw error, since Instatus sometimes is not available and results in many "failed to fetch" errors
    return null;
  }
};
